import cookie from 'react-cookies';
import { AUTH_TOKEN } from '../shared/utils/CookiesManager';
import StateManager from '../shared/utils/StateManager';
import { DashboardStorageManagerInstance } from '../dashboard/DashboardStorageManager';
import { PsRoutes } from '../shared/routing/Routes';

class LoginManager {

    static INSTANCE = new LoginManager();

    static getInstance() {
        return LoginManager.INSTANCE;
    }

    login(token, path) {
        cookie.save(AUTH_TOKEN, token, { path: path });
    }

    logout() {
        cookie.remove(AUTH_TOKEN, {path: '/'}); // Eliminamos el auth token de las cookies
        StateManager.clear(); // Limpiamos todos los estados
        DashboardStorageManagerInstance.clear();
        window.location.assign(PsRoutes.HOME);
    }
}

export const LoginManagerInstance = LoginManager.getInstance();



// WEBPACK FOOTER //
// ./src/app/login/LoginManager.js